"use client";

import Link from "next/link";
import { ComponentPropsWithoutRef, FC } from "react";
import { useLocalizedHref, useMessages } from "../context/i18n";
import { rivalPage as enRivalPage } from "../dictionaries/en/rival-page";
import Typography from "./Typography";

export type RelatedLink = {
  name: string;
  href: string;
};

type AlternativeRelatedProps = {
  links: RelatedLink[];
} & ComponentPropsWithoutRef<"section">;

const AlternativeRelated: FC<AlternativeRelatedProps> = ({ links, ...rest }) => {
  const m = useMessages("rivalPage", enRivalPage);
  const href = useLocalizedHref();
  return (
    <section {...rest}>
      <Typography variant="h3" component="h2" className="text-center">
        {m.relatedTitle}
      </Typography>
      <ul className="mt-8 flex flex-wrap justify-center gap-3">
        {links.map((link) => (
          <li key={link.href}>
            <Link
              href={link.href}
              className="inline-block rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 hover:border-violet-400"
            >
              {m.relatedLink.replace("{name}", link.name)}
            </Link>
          </li>
        ))}
        <li>
          <Link
            href={href("/alternatives")}
            className="inline-block rounded-full border border-violet-200 bg-violet-50 px-4 py-2 text-sm font-medium text-violet-700 hover:border-violet-400"
          >
            {m.relatedAll}
          </Link>
        </li>
      </ul>
    </section>
  );
};

export default AlternativeRelated;
